import React from 'react';
import {Card, Container, Grid, Icon, Modal, Segment,} from 'semantic-ui-react';
import styles from "./supporters.module.css";
import {graphql, StaticQuery} from "gatsby";
import Img from "../utils/Img";

const Supporter = () => (
    <StaticQuery
        query={friendQuery}
        render={data => {
            const values = data.allMarkdownRemark.edges;
            const everyNth1 = (values, nth) => values.filter((e, i) => i % nth === 0);
            const everyNth2 = (values, nth) => values.filter((e, i) => i % nth === 1);
            const everyNth3 = (values, nth) => values.filter((e, i) => i % nth === 2);
            const Friends1 = everyNth1(values, 3).map(i =>
                <Modal size='small' trigger={
                    <Card className={styles.cardPreview}>
                        {
                            !!i.node.frontmatter.image &&
                            <Img className={styles.testimonialPicPreview}
                                 fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                        }
                        <Card.Content>
                            <Card.Header className={styles.cardHeader}>{i.node.frontmatter.title}</Card.Header>
                            <Card.Description className={styles.quotePreview}
                                              dangerouslySetInnerHTML={{__html: i.node.html}}>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                } closeIcon dimmer={'blurring'} size={'small'}>
                    <Modal.Content className={styles.modal}>

                        <Grid className={styles.card}>
                            <Grid.Row columns={1}>
                                {
                                    !!i.node.frontmatter.image &&
                                    <Img className={styles.avatar}
                                         fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                                }
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                    <Container className={styles.quote}
                                               dangerouslySetInnerHTML={{__html: i.node.html}}>
                                    </Container>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <p className={styles.name}><Icon name='like'/>{i.node.frontmatter.title}</p>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            );
            const Friends2 = everyNth2(values, 3).map(i =>
                <Modal size='small' trigger={
                    <Card className={styles.cardPreview}>
                        {
                            !!i.node.frontmatter.image &&
                            <Img className={styles.testimonialPicPreview}
                                 fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                        }
                        <Card.Content>
                            <Card.Header className={styles.cardHeader}>{i.node.frontmatter.title}</Card.Header>
                            <Card.Description className={styles.quotePreview}
                                              dangerouslySetInnerHTML={{__html: i.node.html}}>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                } closeIcon dimmer={'blurring'} size={'small'}>
                    <Modal.Content className={styles.modal}>

                        <Grid className={styles.card}>
                            <Grid.Row columns={1}>
                                {
                                    !!i.node.frontmatter.image &&
                                    <Img className={styles.avatar}
                                         fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                                }
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                    <Container className={styles.quote}
                                               dangerouslySetInnerHTML={{__html: i.node.html}}>
                                    </Container>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <p className={styles.name}><Icon name='like'/>{i.node.frontmatter.title}</p>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            );
            const Friends3 = everyNth3(values, 3).map(i =>
                <Modal size='small' trigger={
                    <Card className={styles.cardPreview}>
                        {
                            !!i.node.frontmatter.image &&
                            <Img className={styles.testimonialPicPreview}
                                 fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                        }
                        <Card.Content>
                            <Card.Header className={styles.cardHeader}>{i.node.frontmatter.title}</Card.Header>
                            <Card.Description className={styles.quotePreview}
                                              dangerouslySetInnerHTML={{__html: i.node.html}}>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                } closeIcon dimmer={'blurring'} size={'small'}>
                    <Modal.Content className={styles.modal}>

                        <Grid className={styles.card}>
                            <Grid.Row columns={1}>
                                {
                                    !!i.node.frontmatter.image &&
                                    <Img className={styles.avatar}
                                         fluid={i.node.frontmatter.image.childImageSharp.fluid}/>
                                }
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                    <Container className={styles.quote}
                                               dangerouslySetInnerHTML={{__html: i.node.html}}>
                                    </Container>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <p className={styles.name}><Icon name='like'/>{i.node.frontmatter.title}</p>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            );
            return (<>
                <Segment className={styles.main}>
                    <Grid container centered stackable columns={'equal'}>
                        <Grid.Column>
                            {Friends1}
                        </Grid.Column>
                        <Grid.Column>
                            {Friends2}
                        </Grid.Column>
                        <Grid.Column>
                            {Friends3}
                        </Grid.Column>
                    </Grid>
                </Segment>
            </>)
        }
        }
    />
);

export default Supporter;

const friendQuery = graphql`
  query friendQuery {
    allMarkdownRemark( 
      filter:{
        frontmatter: {type: { eq: "friends" }}
      }
      sort: { order: DESC, fields: [frontmatter___date] }
      ){
      totalCount
    edges {
      node {
        html
        frontmatter{
          title
          firstname
          lastname
          image{
            childImageSharp {
              fluid(maxHeight: 500 ) {
                  ...GatsbyImageSharpFluid_noBase64
                }
            }
          }
        }
      }
    }
  }
  }
`;